/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
import { apiService } from '@/services/APIService';
import Vue from 'vue';

const CHUNK_SIZE = 250 * 1024;

export default {
  async uploadFile(file, fn = function () {}, maxSizeMb = 5) {
    const img = new Image();
    img.src = file.name;
    const fileSize = file.size;
    const dispositionName = Math.random().toString(32);
    if (fileSize > 1024 * 1024 * Math.max(1, Number(maxSizeMb))) {
      // eslint-disable-next-line no-throw-literal
      throw {
        response: {
          data: {
            result_code: 'VAL01',
            result_message: 'Ошибка валидации',
            validation: {
              file: ['Размер файла слишком большой'],
            },
          },
        },
      };
    }

    let response;

    for (let start = 0; start < fileSize; start += CHUNK_SIZE) {
      const data = new FormData();
      data.append('file', file.slice(start, start + CHUNK_SIZE), dispositionName);

      const promise = apiService.post('/uploads', data, {
        headers: {
          'Content-Type': 'application/octet-stream',
          Accept: 'application/json',
          'Content-Disposition': `attachment; filename=${dispositionName}`,
          'Content-Range': `bytes ${start}-${start + CHUNK_SIZE}/${fileSize}`,
        },
      });

      await Vue.rHandler(
        promise,
        (res) => {
          response = res;
        },
        (err) => {
          response = err.response;
        },
      );

      fn(Math.max((start / fileSize) * 100, 1));
    }
    return response;
  },

  deleteFile(id) {
    return apiService.delete(`/images/${id}`);
  },

  deleteDocument(id) {
    return apiService.delete(`/documents/${id}`);
  },
};
